/* eslint-disable react/jsx-filename-extension */
import { Stack, IGroup, } from '@fluentui/react';
import React, { FC, useContext, } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { CategoryDescriptor, ItemState, SelectedItem, CandidateItem } from './types';
import { DragLayerPreview } from './DragLayerPreview';
import { SelectedColumns } from './SelectedColumns';
import { itemAlignmentsStackPadding } from './utils/style';
import { AvailableColumns } from './AvailableColumns';

interface ColumnChooserProps {
  className?: string;
  selectedItems: SelectedItem[];
  categories: CategoryDescriptor[];
  onAddItems: (newSelectedKeys: CandidateItem[]) => void;
  onSelectedKeysChange: (newSelectedKeys: string[]) => void;
  onCollapseAllClick: () => void;
  onExpandAllClick: () => void;
  onToggleCollapse: (triggerGroup: IGroup) => void;
}

const ColumnChooser: FC<ColumnChooserProps> = (props) => {
  const {
    className = '',
    categories,
    selectedItems,
    onSelectedKeysChange,
    onAddItems,
    onCollapseAllClick,
    onExpandAllClick,
    onToggleCollapse,
  } = props;
  const i18n: any = useContext(I18nContext);
  const availableColumnsSring = i18n.getString(_TL_('Available Columns'));
  const selectedColumnsString = i18n.getString(_TL_('Selected Columns'));

  return (
    <div className={className}>
      <Stack className="column-lists" horizontal tokens={itemAlignmentsStackPadding}>
        <Stack.Item styles={{ root: { width: '48.5%' } }}>
          <DragLayerPreview />
          <AvailableColumns
            categories={categories}
            headerName={availableColumnsSring}
            onCollapseAllClick={onCollapseAllClick}
            onExpandAllClick={onExpandAllClick}
            onToggleCollapse={onToggleCollapse}
            onItemOperationClick={(chosenItem) => {
              if (chosenItem === undefined) {
                throw new Error();
              }
              const newSelectedItemKeys = [...selectedItems.map(item => item.key), chosenItem.key];
              onSelectedKeysChange(newSelectedItemKeys);
            }}
            onAddItems={(items) => {
              onAddItems(items);
            }}
          />
        </Stack.Item>
        <Stack.Item styles={{ root: { width: '3%' } }} >
          <div className="placeholder" />
        </Stack.Item>
        <Stack.Item styles={{ root: { width: '48.5%' } }} >
          <SelectedColumns
            headerName={selectedColumnsString}
            selectedItems={selectedItems}
            onItemOperationClick={(chosenItem) => {
              const newSelectedItemKeys = selectedItems
                .filter(item => item.key !== chosenItem?.key)
                .map(item => item.key);
              onSelectedKeysChange(newSelectedItemKeys);
            }}
            onSelectedItemsChange={(newItems) => {
              const newItemkeys = newItems.map(item => item.key);
              onSelectedKeysChange(newItemkeys);
            }}
            onRemoveAllClick={() => {
              const newItemkeys = selectedItems
                .filter(item => item.state === ItemState.mandatory)
                .map(item => item.key);
              onSelectedKeysChange(newItemkeys);
            }}
          />
        </Stack.Item>
      </Stack>
    </div>
  );
};

export { ColumnChooser };
